<script lang="ts" setup>
import {defineProps, ref} from "vue";
import {Source} from "@/domain/type/source.type.ts";
import {useEntitiesStore} from "@/stores/entities.store.ts";

const props = defineProps<{
  srcRight: Source,
  entityUuid: string
}>();

const store = useEntitiesStore();
const loading = ref(false);

function onClick() {
  loading.value = true;
  store.linkToCompany(props.entityUuid).finally(() => {
    loading.value = false;
  });
}

</script>

<template>
  <v-btn text="Relier" style="width:180px;" @click="onClick" :loading="loading"/>
</template>

<style scoped>

</style>
